import { render, staticRenderFns } from "./Litiges.vue?vue&type=template&id=0bb21d88&scoped=true"
import script from "./Litiges.vue?vue&type=script&lang=js"
export * from "./Litiges.vue?vue&type=script&lang=js"
import style0 from "./Litiges.vue?vue&type=style&index=0&id=0bb21d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb21d88",
  null
  
)

export default component.exports